import { Amplify } from 'aws-amplify';

/**
 * Configure Amplify for Cognito + Google OAuth.
 *
 * We deliberately omit identityPoolId: the admin app authenticates API calls
 * with the Cognito ID token (API Gateway Cognito authorizer), not IAM
 * credentials. Including the Identity Pool breaks Google-federated sign-in.
 */
export function configureAmplify(): void {
  const isLocalhost = window.location.hostname === 'localhost';
  const adminUrl = import.meta.env.VITE_ADMIN_URL || `${window.location.origin}/`;
  const redirectUrl = isLocalhost ? 'http://localhost:5173/' : adminUrl;

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID ?? '',
        userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID ?? '',
        loginWith: {
          oauth: {
            domain:
              import.meta.env.VITE_COGNITO_DOMAIN ??
              'flyinspotter.auth.us-east-1.amazoncognito.com',
            scopes: ['email', 'openid', 'profile'],
            redirectSignIn: [redirectUrl],
            redirectSignOut: [redirectUrl],
            responseType: 'code',
            providers: ['Google'],
          },
        },
      },
    },
  });
}

export const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT ?? '';
